import styled from 'styled-components';

export const CardContainer = styled.div`
  background: white;
  border-radius: 8px;
  padding: 24px;
  display: flex;
  flex-direction: column;
  height: 100%;
  box-shadow: 0 1.5px 4px 0px rgba(0, 0, 0, 0.1);

  @media ${({ theme }) => theme.media.tabletLandscapeMax} {
    padding-bottom: 16px;
  }
`;

export const CardHeader = styled.div`
  margin-bottom: 1px;
  padding-bottom: 20px;
  border-bottom: 1px solid ${({ theme }) => theme.color.ui.grey[20]};
`;

export const CardTitle = styled.h2`
  font-size: 1.5rem;
  font-weight: 500;
  margin: 0 0 12px 0;
  color: ${({ theme }) => theme.color.ui.grey[100]};
`;

export const CardPrice = styled.span`
  font-size: 16px;
  margin: 0;
  color: ${props => (props.isBold ? props.theme.color.ui.grey[100] : props.theme.color.ui.grey[80])};
  font-weight: ${props => (props.isBold ? 500 : 400)};
`;

export const ChargeAmount = styled.span`
  font-size: 16px;
  font-weight: 500;
  color: ${({ theme }) => theme.color.ui.grey[100]};
`;

export const CardDescription = styled.p`
  font-size: 16px;
  margin-bottom: 16px;
  line-height: 24px;
  font-weight: 500;
  color: ${({ theme }) => theme.color.ui.grey[90]};
`;

export const HighlightBox = styled.div`
  background: #f8f7ff;
  padding: 16px;
  border-radius: 12px;
  border: 1px solid #cbc6fc;
  margin-top: 16px;
  margin-bottom: 8px;
  font-size: 14px;
  line-height: 20px;
  color: ${({ theme }) => theme.color.ui.grey[100]};
`;

export const FeatureList = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0;
  flex-grow: 1;
  margin-bottom: 12px;
`;

export const FeatureItem = styled.li`
  font-size: 14px;
  color: ${({ theme }) => theme.color.ui.grey[80]};
  margin-bottom: 12px;
  line-height: 24px;
  display: flex;
  align-items: flex-start;
  gap: 8px;

  @media ${({ theme }) => theme.media.tabletLandscapeMin} {
    font-size: ${props => (!props.isPaidSubscriptionCard ? '16px' : '14px')};
  }

  img {
    flex-shrink: 0;
  }
`;

export const ActionButton = styled.button`
  padding: 16px 24px;
  border-radius: 6px;
  font-size: 16px;
  text-align: center;
  cursor: pointer;
  font-family: inherit;
  text-decoration: none;
  transition: all 0.2s ease;

  ${props =>
    props.variant === 'primary'
      ? `
    background: ${props.theme.color.decorative.magenta[70]};
    color: white;
    border: none;
    font-weight: 400;
  `
      : `
    background: none;
    border: none;
    font-weight: 500;
    border-top: 1px solid ${props.theme.color.ui.grey[20]};
    border-radius: 0px;
    padding-top: 23px;
    color: ${props.theme.color.ui.blue[70]};
    margin-bottom: -8px;
  `}
`;

export const PriceText = styled.p`
  font-size: 16px;
  color: ${({ theme }) => theme.color.ui.grey[100]};
  font-weight: 500;
  text-align: center;
  margin-top: 16px;
  margin-bottom: 16px;
`;

export const ScreenReaderOnly = styled.span`
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
`;

export const FactSheet = styled.div`
  font-size: 16px;
  font-weight: 500;
  display: flex;
  justify-content: center;
  align-items: center;
  color: ${({ theme }) => theme.color.ui.blue[70]};
  border-top: 1px solid ${({ theme }) => theme.color.ui.grey[20]};
  padding-top: 12px;
  a {
    display: flex;
    justify-content: center;
    align-items: center;
    text-decoration: none;
    color: inherit;
    background: none;
    border: none;
    padding: 0;
    margin-top: 3px;
    font: inherit;
    outline: none;
    color: ${({ theme }) => theme.color.ui.blue[70]};
  }
`;
